import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { api } from "../lib/api";
import type { CompareView } from "@shared/types";
import { StatusPill } from "../components/Status";

export function Compare() {
  const [params, setParams] = useSearchParams();
  const left = params.get("left") ?? "ross-river-mike-flood-2013";
  const right = params.get("right") ?? "ross-river-tuflow-2021";
  const [view, setView] = useState<CompareView | null>(null);

  useEffect(() => {
    api<CompareView>(`/api/compare?left=${encodeURIComponent(left)}&right=${encodeURIComponent(right)}`).then(setView).catch(() => setView(null));
  }, [left, right]);

  return (
    <section className="page-hero">
      <div className="wrap-wide">
        <p className="kicker">Cross-model comparison</p>
        <h1>What actually changed.</h1>
        <p className="lede">Material differences are highlighted. Silence stays silence. DEMO rows are labelled.</p>
        <p>
          <button className="btn btn-ghost" type="button" onClick={() => setParams({ left, right })}>
            2013 MIKE FLOOD vs 2021 TUFLOW
          </button>
        </p>
        {view && (
          <>
            <div className="grid-2">
              <article className="card">
                <p className="kicker">Left</p>
                <h3><Link to={`/model/${view.left.slug}`}>{view.left.name}</Link></h3>
                <StatusPill status={view.left.epistemic} />
              </article>
              <article className="card">
                <p className="kicker">Right</p>
                <h3><Link to={`/model/${view.right.slug}`}>{view.right.name}</Link></h3>
                <StatusPill status={view.right.epistemic} />
              </article>
            </div>
            {view.statement && (
              <article className="card" style={{ margin: "24px 0" }}>
                <StatusPill status={view.statementEpistemic} />
                <p>{view.statement}</p>
              </article>
            )}
            <table className="table">
              <thead>
                <tr>
                  <th>Topic</th>
                  <th>{view.left.name}</th>
                  <th>{view.right.name}</th>
                </tr>
              </thead>
              <tbody>
                {view.rows.map((r) => (
                  <tr key={r.topic} className={r.material ? "material" : undefined}>
                    <td>{r.topic}</td>
                    <td>{r.left}</td>
                    <td>{r.right}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </>
        )}
      </div>
    </section>
  );
}
